// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___36yRi","container_1":"container_1___XxTYd","container_2":"container_2___whRTE"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/brands/styles.module.scss
// module id = 445
// module chunks = 0